// 正则类
import i18n from "./i18n";
const REG = {};

REG.validateMobile = /^0?[89]\d{9}$/;
REG.validateMobile1 = /^1[345789]\d{9}$/;
REG.validateMobileMsg = i18n.t("verify.mobileMsg");

REG.validateEmail = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
REG.validateEmailMsg = i18n.t("verify.emailMsg");

// REG.validateZh = (/^[a-zA-Z][a-zA-Z0-9_]{5,14}$/)
// REG.validateZhMsg = '账号必须是字母开头6~15位字母数字组成'
REG.validateZh = /^(?![0-9]+$)[a-zA-Z0-9_]{5,10}$/;
// REG.validateZh = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{5,10}$/;
REG.validateZhMsg = i18n.t("verify.accountMsg");

// REG.validateMm = (/^[a-zA-Z\w]{6,20}$/)
// REG.validateMmMsg = '密码必须是6~20位字母数字组成'
REG.validatePsd = /^(?![^a-zA-Z]+$)(?!\D+$).{8,16}$/;
REG.validatePsdMsg = i18n.t("verify.passwordMsg");

REG.validatePayPsd = /^\d{6}$/;
REG.validatePayPsdMsg = i18n.t("verify.payPsdMsg");

REG.birthday = /^\d{4}(-|\/|\.)\d{1,2}\1\d{1,2}$/;
REG.birthdayMsg = i18n.t("verify.timeMsg");

REG.realname = /^[^\s]*$/;
REG.realnameMsg = i18n.t("verify.realnameMsg");

REG.nickname = /^[\da-z\u4e00-\u9fa5]{2,12}$/i;
REG.nicknameMsg = i18n.t("verify.nicknameMsg");

REG.weChat = /^[a-zA-Z0-9_-]{3,30}$/;
REG.weChatMsg = i18n.t("verify.weChatMsg");

REG.aliPay = /^[a-zA-Z0-9_-]{3,30}$/;
REG.aliPayMsg = i18n.t("verify.aliPayMsg");

REG.bankAccountNumber = /^([1-9]{1})(\d{15,18})$/;
REG.bankCardNumberMsg = i18n.t("verify.bankCardNumberMsg");

export default REG;
